// extracted by mini-css-extract-plugin
module.exports = {"header":"_app_header__LFvey"};